<arivo-alerts></arivo-alerts>

<div>
  <div class="mb-8">
    <app-billing-account-balance></app-billing-account-balance>
  </div>
  <div>
    <arivo-tabs>
      @if (showPayPerUse) {
        <arivo-tab
          [title]="'Billing.ShortTermParkingTitle' | translate"
          icon="fa-kit fa-time"
          [active]="!tab || tab === 'parking'"
          urlParamKey="parking"
        >
          <app-billing-park-sessions></app-billing-park-sessions>
        </arivo-tab>
      }
      <arivo-tab [title]="'Billing.InvoicesTitle' | translate" icon="fa-kit fa-wallet" [active]="tab === 'invoices'" urlParamKey="invoices">
        <app-billing-invoices></app-billing-invoices>
      </arivo-tab>
      @if (showArchivedInvoices) {
        <arivo-tab
          [title]="'Billing.ArchivedInvoicesTitle' | translate"
          icon="fa-light fa-box-archive"
          [active]="tab === 'archived-invoices'"
          urlParamKey="archived-invoices"
        >
          <app-billing-invoices invoiceSource="archived"></app-billing-invoices>
        </arivo-tab>
      }
    </arivo-tabs>
  </div>
</div>
